<template>
    <div>
        <!-- <button @click="openBlockProds = !openBlockProds" class="button-default" style="margin:auto" v-text="getString('bloquear_desbloquear_produtos')"></button> -->
        <div class="block-prods-container" v-if="true">
            <div class="title-box">
                <h2>{{ taxValidationMode ? getString('validacao_fiscal_produtos') : getString('bloquear_desbloquear_produtos') }}</h2>
            </div>

            <!-- Abas de filtro: apenas no modo de validação fiscal -->
            <div class="tax-tabs" v-if="taxValidationMode">
                <button
                    class="tax-tab"
                    :class="{ 'tax-tab--active': activeTaxTab === 'pending' }"
                    @click="activeTaxTab = 'pending'"
                >
                    {{ getString('com_pendencia_fiscal') }}
                    <span class="tax-tab__badge" v-if="taxValidationData && taxValidationData.productsWithPending">
                        {{ taxValidationData.productsWithPending.length }}
                    </span>
                </button>
                <button
                    class="tax-tab"
                    :class="{ 'tax-tab--active': activeTaxTab === 'noTax' }"
                    @click="activeTaxTab = 'noTax'"
                >
                    {{ getString('sem_imposto') }}
                    <span class="tax-tab__badge" v-if="taxValidationData && taxValidationData.productsWithoutTax">
                        {{ taxValidationData.productsWithoutTax.length }}
                    </span>
                </button>
            </div>

            <div class="search-box">
                <label for="search">{{ getString('pesquisar') }}</label>
                <input type="text" autocomplete="off" id="search" name="search" v-model="search" @focus="show" data-layout="normal"/>
                <DefaultButton :text="getString('limpar')" @defaultBtnClick="search = ''" :outlined="true"></DefaultButton>
            </div>
            <ul>
                <li v-for="(item, key) in listToShow" :key="key">
                    <input
                        type="checkbox"
                        :id="'block_prod_item'+ key"
                        :name="'block_prod_item'+ key"
                        v-model="item.active"
                        @change="onProdBlockChange((item.subItemCode || item.productCode), item.active)"
                    />
                    <label :for="'block_prod_item'+ key">
                        <span class="prod-label-code">{{ item.subItemCode || item.productCode }}</span>
                        <span class="prod-label-name">{{ getProdTradName(item) }}</span>
                        <!-- Detalhes fiscais: apenas no modo pendência fiscal -->
                        <span class="prod-tax-detail" v-if="taxValidationMode && activeTaxTab === 'pending' && item.taxCode !== undefined">
                            <!-- span v-if="item.taxCode">NCM: {{ item.ncmCode || '—' }} | CFOP: {{ item.cfopPFISCode || '—' }}</!-->
                            <!-- span v-else class="prod-tax-missing">{{ getString('sem_codigo_fiscal') }}</!-->
                        </span>
                    </label>
                </li>
                <li v-if="listToShow.length === 0" class="empty-list">
                    <span>{{ getString('nenhum_produto_encontrado') }}</span>
                </li>
            </ul>
            <div class="prod-item-footer">
                <DefaultButton :text="getString('concluir')" @defaultBtnClick="apply()"></DefaultButton>
            </div>
            <vue-touch-keyboard id="keyboard" :options="options" v-if="visible" :layout="layout" :cancel="hide" :accept="accept" :input="input"/>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import productController from '@/assets/controllers/ProductController'
import LocaleController from '@/assets/controllers/LocaleController'
import Util from '@/assets/libs/util'
import DefaultButton from '@/components/DefaultButton'
import VueTouchKeyboard from 'vue-touch-keyboard'
import style from 'vue-touch-keyboard/dist/vue-touch-keyboard.css'

Vue.use(VueTouchKeyboard)
Vue.use(style)

export default {
    name: 'ProdBloqsContainer',
    components: {
        DefaultButton,
        'vue-touch-keyboard': VueTouchKeyboard.component
    },
    props: {
        taxValidationMode: {
            type: Boolean,
            default: false
        },
        taxValidationData: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            visible: false,
            listToShow: [],
            layout: 'normal',
            options: {
                useKbEvents: false,
                preventClickEvent: false
            },
            input: null,
            openBlockProds: false,
            edit_icon: require('../../static/icons/close_white.svg'),
            somethingChange: false,
            search: '',
            activeTaxTab: 'pending'
        }
    },
    methods: {
        accept: function (text) {
            this.hide()
        },
        show: function (e) {
            if (!Util.isAndroidMode()) {
                this.input = e.target
                this.layout = e.target.dataset.layout
                if (!this.visible) {
                    this.visible = true
                }
            }
        },
        hide: function () {
            this.visible = false
        },
        getString: function (key) {
            return LocaleController.getString(key)
        },
        getProdTradName: function (item) {
            const currentLanguage = LocaleController.getCurrentLanguage()
            const langknownProps = {
                'pt-br': item.subItemName || item.productName,
                'en': item.subItemNameEnglish || item.productNameEnglish,
                'es': item.subItemNameEspanish || item.productNameEspanish
            }
            return langknownProps[currentLanguage] || langknownProps['pt-br']
        },
        getProdList: async function () {
            if (this.taxValidationMode && this.taxValidationData) {
                const rawList = this.activeTaxTab === 'pending'
                    ? (this.taxValidationData.productsWithPending || [])
                    : (this.taxValidationData.productsWithoutTax || [])

                let itemList = rawList.map(p => ({
                    ...p,
                    subItemCode: null,
                    subItemName: null,
                    productName: p.productName,
                    productCode: p.productCode
                }))

                if (this.search) {
                    const q = this.search.toLocaleLowerCase()
                    itemList = itemList.filter(item =>
                        (item.productName || '').toLocaleLowerCase().includes(q) ||
                        (item.productCode || '').toLocaleLowerCase().includes(q)
                    )
                }

                const blockList = Util.getLocalVar('blockProds') || []
                itemList.forEach(item => {
                    item.active = blockList.includes(item.productCode)
                })

                this.listToShow = itemList
                return
            }

            productController.getProducts().then(prods => {
                let itemList = productController.getProdItem('unique')
                if (itemList.length === 0) {
                    Util.showInfoModal(this.getString('nao_ha_itens'))
                    this.$emit('toggleProdBolck')
                }
                if (this.search) {
                    const self = this
                    itemList = itemList.filter((item) => {
                        const curProdName = self.getProdTradName(item)
                        let isProdName = curProdName.toLocaleLowerCase().includes(self.search.toLocaleLowerCase())
                        let isProdCode = (item.subItemCode || item.productCode).toLocaleLowerCase().includes(self.search.toLocaleLowerCase())

                        if (isProdCode || isProdName) {
                            return item
                        }
                    })
                }
                for (let itemIndex = 0; itemIndex < itemList.length; itemIndex++) {
                    const item = itemList[itemIndex]
                    const code = item.subItemCode || item.productCode
                    item.active = Util.getLocalVar('blockProds') && Util.getLocalVar('blockProds').includes(code)
                }
                this.listToShow = itemList
            })
        },
        onProdBlockChange: function (prodCode, status) {
            let blockList = Util.getLocalVar('blockProds')
            if (status) {
                if (!blockList.includes(prodCode)) {
                    blockList.push(prodCode)
                    Util.setLocalVar('blockProds', blockList)
                }
            } else {
                Util.setLocalVar('blockProds', blockList.filter(p => p !== prodCode))
            }
            this.somethingChange = true
            productController.addRemoveBloqProducts(prodCode, status)
        },
        apply: function () {
            this.$emit('toggleProdBolck')
        },
        makeProdBlock: async function () {
            if (this.taxValidationMode) {
                // No modo fiscal a lista vem pronta via prop; apenas garante blockProds inicializado
                let listProdBLock = Util.getLocalVar('blockProds')
                if (!listProdBLock) {
                    Util.setLocalVar('blockProds', [])
                }
                await this.getProdList()
                return
            }
            let listProdBLock = Util.getLocalVar('blockProds')
            if (!listProdBLock) {
                listProdBLock = await productController.getBlockProducts()
                Util.setLocalVar('blockProds', listProdBLock)
            }
            await this.getProdList()
        }
    },
    mounted () {
        this.makeProdBlock()
        // this.getProdList()
    },
    watch: {
        search: function () {
            this.getProdList()
        },
        activeTaxTab: function () {
            this.search = ''
            this.getProdList()
        },
        taxValidationData: function () {
            this.getProdList()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import (reference) url("../assets/common.less");
.block-prods-container {
    font-size: 1.4rem;
    position: fixed;
    left: 75px;
    right: 75px;
    top: 50%;
    transform: translateY(-50%);
    background: @white;
    border-radius: 25px;
    z-index: 30;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    height: 790px;
    .title-box {
        background-color: @primary-color;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 25px 25px 0px 0px;
        height: 120px;
        h2 {
            color: @white;
            margin: auto;
        }
    }
    .tax-tabs {
        display: flex;
        background-color: @primary-dark;
        .tax-tab {
            flex: 1;
            padding: 10px 8px;
            font-size: 1.3rem;
            font-weight: bold;
            color: rgba(255,255,255,0.65);
            background: transparent;
            border: none;
            border-bottom: 3px solid transparent;
            cursor: pointer;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            &--active {
                color: @white;
                border-bottom-color: @white;
                background: rgba(255,255,255,0.1);
            }
            &__badge {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                min-width: 22px;
                height: 22px;
                padding: 0 6px;
                border-radius: 11px;
                background: rgba(255,255,255,0.25);
                font-size: 1.1rem;
                font-weight: normal;
            }
        }
    }
    .search-box {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 60px;
        background-color: @primary-light;
        button {
            height: 45px !important;
            min-width: 100px !important;
        }
        input {
            height: 40px;
            width: 375px;
            margin: 0 30px 0 30px;
            font-size: 120%;
            border: solid 1px @primary-dark;
        }
        label {
            color: white;
            font-size: 1.8rem;
        }
    }
    ul {
        list-style: none;
        height: calc(500px - 130px);
        overflow: auto;
        background: white;
        padding: 30px;
        border-radius: 5px;
        // width: 775px;
        width: inherit;
        &:before{
            content: attr(aria-label);
            font-size: 120%;
            font-weight: bold;
            margin: -15px 0 0 -15px;
            display: block;
            position: sticky;
            top: -30px;
            background: white;
            color: @primary-color;
        }
        li {
            border-bottom: solid 1px rgb(83, 83, 83);
            padding: 5px 0;
            input {
                display: inline-block;
                width: 30px;
                height: 30px;
            }
            label {
                display: inline-flex;
                flex-direction: column;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: calc(100% - 70px);
                vertical-align: top;
                .prod-label-code {
                    font-weight: bold;
                    font-size: 0.95em;
                }
                .prod-label-name {
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .prod-tax-detail {
                    font-size: 0.78em;
                    color: #666;
                    margin-top: 2px;
                    .prod-tax-missing {
                        color: #c0392b;
                        font-style: italic;
                    }
                }
            }
            &.empty-list {
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 20px 0;
                color: #888;
                font-style: italic;
            }
        }
    }
    /*button.float {
        position: relative;
        width: 100px;
        display: block;
    } */
    .prod-item-footer {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.1);
        height: 130px;
        border-radius: 0px 0px 25px 25px;
        button {
            position: relative;
            display: block;
            margin: auto;
        }
    }
    #keyboard {
        .keyboard;
        max-width: 95%;
        font-size: 18px;
        position: fixed;
        bottom: 0;
    }
}
    @media (min-width: 699px) and (max-width: 1025px) { //@tablet
        .block-prods-container {
            .search-box {
                input {
                    height: 40px;
                    width: 250px;
                }
                label {
                    color: white;
                    font-size: 1.6rem;
                }
            }
            #keyboard {
                max-width: 95%;
                font-size: 18px;
                position: fixed;
                bottom: 0;
            }
        }
    }
    @media (max-width: 698px) { // Gertec SK210
        .block-prods-container {
            font-size: 15px;
            margin: auto;
            height: 500px;
            width: 400px;
            left: 50px;
            right: 50px;
            .title-box {
                height: 50px;
                h2 {
                    font-size: 20px;
                }
            }
            .search-box {
                height: 60px;
                input {
                    font-size: 20px;
                    height: 30px;
                    padding: 0 10px;
                    width: 150px;
                    margin: 0 10px 0 10px;
                }
                label {
                    font-size: 20px;
                }
            }
            ul {
                height: calc(350px - 60px);
                width: 390px;
                li {
                    input {
                        width: 20px;
                        height: 20px;
                    }
                    label {
                        font-size: 1.2em;
                    }
                }
            }
            .prod-item-footer {
                height: 60px;
            }
        }
    }

    @media (orientation: landscape) {
        .block-prods-container {
            font-size: 15px;
            margin: auto;
            height: max-content;
            width: max-content;
            .title-box {
                height: 50px;
                h2 {
                    font-size: 25px;
                }
            }
            .search-box {
                height: 60px;
                input {
                    font-size: 20px;
                    height: 30px;
                    padding: 0 10px;
                    width: 200px;
                    margin: 0 10px 0 10px;
                }
                label {
                    font-size: 20px;
                }
            }
            ul {
                height: calc(350px - 0px);
                width: 650px;
                li {
                    input {
                        width: 20px;
                        height: 20px;
                    }
                }
            }
            .prod-item-footer {
                margin: 15px 0 0 0;
                height: 0 !important;
                bottom: 70px !important;
            }
            #keyboard {
                max-width: 95%;
                font-size: 15px;
                position: fixed;
                bottom: 0;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/ProdBloqsContainer.vue